

import { Component, Vue } from 'vue-property-decorator';
import { api } from '../Api';
import { helper } from '../Utils/Helper';
import { phoneManager } from '../Utils/PhoneManager';

@Component({})
export default class RgFetcher extends Vue {

    page = 1
    rgs: any[] = []
    data: any[] = []
    branch: any = null
    questions: any[] = []
    start: any = null
    end: any = null
    fields = {
        'Date': 'date',
        'Branche': 'branch',
        'Noms': 'name',
        'Prénoms': 'surname',
        'Contact': 'contact',
        'Email': 'email',
        'Dernière question': 'lastQuestion',
        'Taux de remplissage': 'percent',
        'Lien': 'url',
    }
    mounted() {
        // const now = new Date();

        // this.start = new Date(now.getFullYear(), now.getMonth(), 1);
        // const startMonth = now.getMonth() + 1
        // this.start = now.getFullYear() + '-' + (startMonth > 9 ? startMonth : '0' + startMonth) + '-' + '01'

        // const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        // const endMonth = end.getMonth() + 1
        // this.end = end.getFullYear() + '-' + (endMonth > 9 ? endMonth : '0' + endMonth) + '-' + end.getDate()
        // this.load()
    }

    load() {
        // console.log(this.checkNumber('140676370'));
        // return
        this.page = 1
        this.loadBranch()
        this.loadPage()
    }
    search() {
        this.data = []
        this.page = 1
        this.loadPage()
    }

    async loadBranch() {
        const res = await api.client.get(process.env.VUE_APP_BACKEND_URL + 'front/api/load/branch/auto')
        this.branch = res.data.branch
        this.questions = []
        this.branch.steps.forEach((step: any) => {
            if (step.activated && !step.deleted) {
                step.sections.forEach((section: any) => {
                    if (section.activated && !section.deleted) {
                        section.questions.forEach((question: any) => {
                            if (question.activated && !question.deleted) {
                                this.questions.push(question)
                            }
                        })
                    }
                })
            }
        })
        this.questions.forEach((q: any, index) => {
            this.fields[index + '-' + q.label] = 'q_' + q.id
            //     // console.log(q.label)
        })

    }

    async loadPage() {

        // const start = this.start.getFullYear() + '-' + (this.start.getMonth() > 9 ? this.start.getMonth() : '0' + this.start.getMonth()) + '-' + (this.start.getDate() > 9 ? this.start.getDate() : '0' + this.start.getDate())
        // const end = this.start.getFullYear() + '-' + (this.start.getMonth() > 9 ? this.start.getMonth() : '0' + this.start.getMonth()) + '-' + (this.start.getDate() > 9 ? this.start.getDate() : '0' + this.start.getDate())
        const res = await api.client.get('load/rg/' + this.page + '/' + this.start + '/' + this.end)
        if (res.data.rgs.length > 0) {
            res.data.rgs.forEach((rg) => {
                if (rg.percent > 0) {
                    let valid = true
                    if (!helper.empty(rg.sub.contact)) {
                        valid = this.checkNumber(rg.sub.contact)
                        rg.sub.contact = rg.sub.contact
                    }
                    if (valid && !helper.empty(rg.sub.email)) {
                        valid = this.checkEmail(rg.sub.email)
                    }
                    if (valid) {
                        this.appendRg(rg)
                    }
                }
            })
            this.rgs = this.rgs.concat(res.data.rgs)
            // console.log(this.page)
            this.page++
            this.loadPage()
        }
        // console.log(this.rgs[0])
    }
    appendRg(rg) {
        const data = {
            date: helper.readable(rg.createdAt, true, true),
            branch: rg.branch.title,
            name: rg.sub.name,
            prename: rg.sub.surname,
            contact: helper.phoneFormat(rg.sub.contact),
            email: rg.sub.email,
            lastQuestion: rg.lastQuestion ? rg.lastQuestion.label : '-',
            percent: rg.percent + '%',
            url: 'https://comparateur.wiassur.com/' + rg.url
        }
        // console.log('================================')
        this.questions.forEach((q: any) => {
            const res = rg.responses.find((response: any) => {
                // console.log(response.question.id + ' !== ' + q.id)
                return response.question.id === q.id
            })
            if (res) {
                if (q.responseType.code === 'choice') {
                }
                // console.log(q)
                const option = q.options.find((o: any) => {
                    return o.code === res.value
                })
                if (option) {
                    res.value = option.label
                }
                // console.log(q.label + ' => ' + res.value)
                data['q_' + q.id] = res.value
            } else {
                data['q_' + q.id] = '-'
            }
            // if(q.label === 'Marque'){
            // console.log('Marque '+res)
            // }

        })
        this.data.push(data)
    }
    findAnswer(rg, question) {
        const res = rg.responses.find((response: any) => {
            response.question.id === question.id
        })
    }

    checkNumber(number) {
        const avoid = ['89986979', '0789986979']
        return !avoid.includes(number) && phoneManager.verify(number)
    }


    checkEmail(email) {
        const avoid = ['stephane2080@gmail.com', 'teva01@gmail.com']
        if (avoid.includes(email.toLowerCase()) || avoid.includes('@mailinator')) {
            return false
        }
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return true
        }
        return false
    }



}

